import * as Store from '../../../weborder/Store';
import { getPalette } from './config/palette';

export const getPaletteVars = () => {
  const store = Store.getStoreInstance();
  const state = store?.getState();

  const primaryColor = state ? state.appDesignScheme.Primary : '#000000';

  return getPalette(primaryColor);
};
